import { render, staticRenderFns } from "./SoftwareProductProviders.vue?vue&type=template&id=0fe82144&scoped=true"
import script from "./SoftwareProductProviders.vue?vue&type=script&lang=js"
export * from "./SoftwareProductProviders.vue?vue&type=script&lang=js"
import style0 from "./SoftwareProductProviders.vue?vue&type=style&index=0&id=0fe82144&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe82144",
  null
  
)

export default component.exports